module.exports = __webpack_public_path__ + "img/f3.f80a0140.jpg";